// src/components/TitleHeader.jsx
import * as React from "react";
import PropTypes from "prop-types";
import { Box, Stack, Typography } from "@mui/material";

export default function TitleHeader({
  title,
  subtitle,
  children,
  actions,
  divider = true,
  dividerWidth = 40,
  gutterBottom = 2,
  titleVariant = "h3",
  subtitleVariant = "body2",
  sx,
  ...stackProps
}) {
  const right = children ?? actions;
  const hasSubtitle = !!subtitle;

  return (
    <Box sx={{ width: "100%", mb: gutterBottom, ...sx }}>
      {/* Row 1: Title (and actions if no subtitle) */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1.5}
        {...stackProps}
      >
        <Typography variant={titleVariant}>{title}</Typography>

        {!hasSubtitle && right ? (
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "flex-end",
              ml: 2,
            }}
          >
            {right}
          </Box>
        ) : null}
      </Stack>

      {/* Row 2: subtitle + actions (only when subtitle exists) */}
      {hasSubtitle && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1.5}
          sx={{ mt: 0.5 }}
          {...stackProps}
        >
          <Typography
            variant={subtitleVariant}
            color="text.secondary"
            sx={{ mr: 2, flex: "1 1 auto", minWidth: 0 }}
          >
            {subtitle}
          </Typography>

          {right ? (
            <Box
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
                flexWrap: "wrap",
                justifyContent: "flex-end",
              }}
            >
              {right}
            </Box>
          ) : null}
        </Stack>
      )}

      {/* Accent divider bar */}
      {divider ? (
        <Box
          sx={{
            mt: 1,
            height: 3,
            width: dividerWidth,
            borderRadius: 2,
            bgcolor: "secondary.main",
          }}
        />
      ) : null}
    </Box>
  );
}

TitleHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.node,
  divider: PropTypes.bool,
  dividerWidth: PropTypes.number,
  gutterBottom: PropTypes.number,
  titleVariant: PropTypes.string,
  subtitleVariant: PropTypes.string,
  sx: PropTypes.object,
};
